"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocation = exports.getTrackingQueryString = exports.trackEvent = exports.logQueryString = exports.logTrackingData = exports.getPageData = exports.getSiteSubSubSection = exports.getSiteSubSection = exports.getSiteSection = exports.getPageType = exports.getPageTitle = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getPageTitle = function getPageTitle(path) {
  var parts = path.split("/").filter(Boolean);
  var pageTitle = parts.pop();

  if (pageTitle !== undefined) {
    return pageTitle.replace(".html", "");
  }

  return pageTitle || "home";
};

exports.getPageTitle = getPageTitle;

var getPageType = function getPageType(path) {
  return path === "/" ? "home-page" : "information-page";
};

exports.getPageType = getPageType;

var getSiteSection = function getSiteSection(path) {
  return path === "/" ? "home" : "information";
};

exports.getSiteSection = getSiteSection;

var getSiteSubSection = function getSiteSubSection(path) {
  var parts = path.split("/").filter(Boolean);
  return parts.shift() || "home";
};

exports.getSiteSubSection = getSiteSubSection;

var getSiteSubSubSection = function getSiteSubSubSection(path) {
  var parts = path.split("/").filter(Boolean);
  return parts.length === 3 ? parts[1] : "";
};

exports.getSiteSubSubSection = getSiteSubSubSection;

var getPageData = function getPageData(path, exceptions) {
  var pageData = {
    page_pageTitle: getPageTitle(path),
    page_pageType: getPageType(path),
    page_siteSection: getSiteSection(path),
    page_siteSubSection: getSiteSubSection(path)
  };
  var siteSubSubSection = getSiteSubSubSection(path);

  if (siteSubSubSection) {
    pageData.page_siteSubSubSection = siteSubSubSection;
  }

  exceptions.forEach(function (exception) {
    // using pathMatch is more flexible,
    // overrides the default variable if specified if there is match on path
    if (exception.isRegex) {
      exception.pathMatch = new RegExp(exception.pathMatch);
    }

    if (exception.pathMatch) {
      if (exception.pathMatch instanceof RegExp && exception.pathMatch.test(path) || exception.pathMatch === path) {
        var mapper = {
          productid: "product_productid",
          sitesection: "page_siteSection",
          subsection: "page_siteSubSection",
          subsubsection: "page_siteSubSubSection",
          pagetype: "page_pageType",
          pagetitle: "page_pageTitle"
        };
        Object.keys(mapper).forEach(function (key) {
          if (exception[key] && exception[key] !== 'na') {
            //$FlowFixMe
            pageData[mapper[key]] = exception[key];
          } // remove key from pageData if value passing as na, not to show


          if (exception[key] === 'na') {
            delete pageData[mapper[key]];
          }
        });
      }
    } else if (exception.subsection === pageData.page_siteSubSection) {
      pageData.page_siteSection = exception.sitesection;

      if (exception.pagetype !== "") {
        pageData.page_pageType = exception.pagetype;
      }
    }
  });
  return pageData;
};

exports.getPageData = getPageData;

var logTrackingData = function logTrackingData(eventType, _ref) {
  var siteData = _ref.siteData,
      pageData = _ref.pageData,
      eventData = _ref.eventData;

  try {
    if (typeof window !== "undefined" && window.localStorage.getItem("tealiumDebugMode")) {
      // eslint-disable-next-line no-console
      console.log(eventType, {
        siteData: siteData,
        pageData: pageData,
        eventData: eventData
      });
    }
  } catch (e) {// Handles following exception thrown from incognito iframe, ok with no debugging
    // DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
  }
};

exports.logTrackingData = logTrackingData;

var logQueryString = function logQueryString(queryString) {
  if (typeof window !== "undefined" && window.localStorage.getItem("tealiumDebugMode")) {
    // eslint-disable-next-line no-console
    queryString && console.log({
      queryString: queryString
    });
  }
};

exports.logQueryString = logQueryString;

var trackEvent = function trackEvent(analytics, event) {
  if (analytics.tealium && analytics.tealium.inject) {
    var trackingData = _objectSpread({}, analytics, {
      eventData: {
        event: event
      }
    });

    analytics.tealium.inject.trackEvent(trackingData);
    logTrackingData("trackEvent", trackingData);
  }
};

exports.trackEvent = trackEvent;

var getTrackingQueryString = function getTrackingQueryString(analytics, event) {
  var queryString = "";

  if (analytics.tealium && analytics.tealium.inject) {
    var trackingData = _objectSpread({}, analytics, {
      eventData: {
        event: event
      }
    });

    queryString = analytics.tealium.inject.getTrackingQueryString(trackingData);
  }

  logQueryString(queryString);
  return queryString;
};

exports.getTrackingQueryString = getTrackingQueryString;

var setLocation = function setLocation(context, location) {
  var _context = _slicedToArray(context, 2),
      analytics = _context[0],
      setAnalytics = _context[1];

  var trackingData = _objectSpread({}, analytics, {
    eventData: _objectSpread({}, analytics.eventData, {
      event_location: location
    })
  });

  setAnalytics(trackingData); //$FlowFixMe

  logTrackingData("setLocation", trackingData);
};

exports.setLocation = setLocation;